<toaster #toasterInstance></toaster>
<div class="customer-home">
  <section class="customer-home__hero hero">
    <div class="hero__image-group">
      <div class="hero__image" [ngClass]="getImageClassLeft()"></div>
      <div class="hero__image" [ngClass]="getImageClassRight()"></div>
    </div>
    <div *ngIf="!hasAgentQuote" class="hero__content--desktop">
      <h1 class="hero__title">Get peace of mind to live your life</h1>
      <h3 class="hero__subtitle">
        Use Coverpath’s simple online process to apply for quality MassMutual life insurance
        <br />
        and show them how much you care.
      </h3>
      <div class="hero__button-container" *ngIf="!nbDecommissionPost30Days && !loggedIn && doesQuickQuoteExist()">
        <button class="hero__button button button--primary button--yellow" role="button" (click)="scrollToQuickQuote()">
          Get a Quote
        </button>
      </div>
    </div>
  </section>
  <section class="customer-home__main-content" *ngIf="!loggedIn">
    <ng-container *ngIf="hasAgentQuote">
      <div class="quote-card-container">
        <ng-container *ngIf="isFinishedLoading(); else quoteLoading">
          <ng-container *ngIf="quoteType === 'annuity'; else nonAnnuity">
            <annuity-quote-card></annuity-quote-card>
          </ng-container>
          <ng-template #nonAnnuity>
            <quote-card *ngIf="!isConversionInvite"></quote-card>
            <quote-card-conversion *ngIf="isConversionInvite"></quote-card-conversion>
          </ng-template>
        </ng-container>
        <ng-template #quoteLoading>
          <div class="quote-card quote-card--loading">
            <spinner color="white" size="small"></spinner>
            <h2 class="quote-card--loading__text">We're loading your information...</h2>
          </div>
        </ng-template>
      </div>
    </ng-container>
    <div class="features">
      <div *ngIf="!hasAgentQuote" class="hero__content--mobile">
        <h1 class="hero__title">Get peace of mind to live your life</h1>
        <h3 class="hero__subtitle">
          Use Coverpath’s simple online process to apply for quality MassMutual life insurance
          <br />
          and show them how much you care.
        </h3>
        <div *ngIf="!nbDecommissionPost30Days" class="hero__button-container">
          <a class="hero__button button button--primary button--yellow" role="button" (click)="scrollToQuickQuote()">
            Get a Quote
          </a>
        </div>
      </div>
      <div class="features__content" *ngIf="quoteType !== 'joint' && quoteType !== 'annuity'">
        <h1 class="features__title">How it works</h1>
        <div class="features__divider"></div>
        <div class="features__group">
          <div class="features-item">
            <div class="features-item__icon">
              <img class="features-item__icon-img" src="/img/components/home/icon-quote.svg" />
            </div>
            <div class="features-item__text">
              <h3 class="features-item__title">Get your quote</h3>
              <p class="features-item__desc">
                Work with your {{ advisorDescriptiveNoun }} to understand the coverage you need and get an estimated
                price.
              </p>
            </div>
          </div>
          <div class="features-item">
            <div class="features-item__icon">
              <img class="features-item__icon-img" src="/img/components/home/icon-clock.svg" />
            </div>
            <div class="features-item__text">
              <h3 class="features-item__title">Apply Online</h3>
              <p class="features-item__desc">
                Complete our simple online application with expert guidance if you need it.
              </p>
            </div>
          </div>
          <div class="features-item">
            <div class="features-item__icon">
              <img class="features-item__icon-img" src="/img/components/home/icon-check.svg" />
            </div>
            <div class="features-item__text">
              <h3 class="features-item__title">Get a Decision</h3>
              <p class="features-item__desc">
                If approved, get your final price and start coverage. You just got peace of mind.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="customer-home__our-difference" *ngIf="quoteType !== 'joint' && quoteType !== 'annuity'">
    <div class="image-text">
      <div class="image-text__img-container">
        <img class="image-text__image" src="/img/components/home/Customer_LP_683807862_low.jpg" />
      </div>
      <div class="image-text__text">
        <h1 class="image-text__title">A new way to get MassMutual insurance</h1>
        <div class="image-text__divider"></div>
        <ng-container [ngSwitch]="quoteType">
          <p class="image-text__description" *ngSwitchCase="'whole'">
            Since 1851, MassMutual has been helping people protect their future and the ones they love. With
            MassMutual’s Coverpath platform, you can apply online for a quality whole life insurance policy issued by
            MassMutual. And you can still have the expert guidance of your {{ advisorDescriptiveNoun }} along the way.
            Coverpath helps you get insurance for your life today.
          </p>
          <p class="image-text__description" *ngSwitchDefault>
            Since 1851, MassMutual has been helping people protect their future and the ones they love. With Coverpath,
            you can apply online for a quality, convertible term life insurance policy issued by MassMutual. You can
            keep your policy when you change jobs, and convert it to permanent insurance if your needs change. And you
            still have the expert guidance of your {{ advisorDescriptiveNoun }} along the way. Coverpath helps you get
            insurance for your life today.
          </p>
        </ng-container>
      </div>
    </div>
  </section>
  <section
    class="customer-home__quick-quote"
    id="quick-quote"
    *ngIf="(isGeneric() || termQuoteNotART) && !appSubmitted && !loggedIn"
  >
    <div *ngIf="!nbDecommissionPost30Days" class="quick-quote">
      <quick-quote></quick-quote>
    </div>
  </section>
</div>
